



import React from "react";
import img1 from '../../images/service/SEO Service_result.webp'
import img2 from '../../images/service/App Development_result.webp'
import img3 from '../../images/service/SMO Services_result.webp'
import img4 from '../../images/service/Graphic Designing_result.webp'
import img5 from '../../images/service/Video Editing_result.webp'
import img6 from '../../images/service/UI UX Development_result.webp'
import img7 from '../../images/service/Custom Software_result.webp'
import img8 from '../../images/service/E-Commerce_result.webp'
import img9 from '../../images/service/Web Development_result.webp'

const WhyChooseUs = ({ slug }) => {
    
  // Content and image mapping based on slug
  const contentMap = {
    "seo-services": {
      title: "SEO Company in Alwar?",
      content: "Partnership with RashTech Info is a partnership with the Best SEO Company in Alwar with both local and global market insight. We've been providing ROI-driven SEO strategies since 2018 with the objectives of improving rankings, driving organic traffic, and optimizing the return on investment. Our experts are experts in Local SEO in Alwar, making businesses show up for 'near me' searches, and Advanced SEO Services for competitive niches. In contrast to commonplace agencies, we design bespoke SEO strategies depending on your business objectives, competition, and audience.",
      image: img1,
      listItems: ['Targeted keyword research to attract the right audience.',
        "On-page optimization to improve your website's content.",
        "High-quality link building for better search rankings.",
        "Regular technical audits to fix website performance issues.",
        "Continuous performance tracking for sustained business growth."
      ]
    },
    "app-development-services": {
      title: "Top App Development Company in Alwar?",
      content: "RashTech Info is the choice that ensures collaboration with a company that is well-aware of the local as well as international markets. Having experienced developers onboard, we provide scalable, secure, and business-ready apps. The goal is to provide measurable results, ranging from improved user engagement to greater revenue.",
      listItems: [
        "Android, iOS & Cross-platform expertise",
        "Excellent portfolio with clients both in India & globally",
        "Enterprise-grade quality at affordable prices",
        "Full-fledged development assistance from concept to launch",
        "Round-the-clock updates & support team"
      ],
      image: img2
    },
    "smo-services": {
      title: "Top SMO Company in Alwar?",
      content: "Partnership with RashTech Info implies collaboration with a group of professionals who know how to develop companies on social media. With our expertise as a reliable Social Media Optimization Company in India, we assist brands in achieving visibility, authority, and engagement with their target audience.",
      listItems: [
        "Seasoned expertise on Facebook, Instagram, LinkedIn, YouTube & more",
        "Innovative content plans to maximize reach and engagement",
        "Competitive pricing with quantifiable results",
        "Tailored SMO campaigns for domestic and international markets",
        "Clear reporting and sustained growth"
      ],
      image: img3
    },
    "graphic-design-services": {
      title: "Best Graphic Design Company in Alwar?",
      content: "With RashTech Info, you are availing yourself of an imaginative team that well knows how design can make an enterprise a successful one. As a reliable Graphic Design Company in India, we mix creative art with marketing acumen to offer you designs that appeal to your targeted audience.",
      listItems: [
        "Expertise in branding, logo, and marketing creatives",
        "Strong portfolio of local and international customers",
        "Affordable prices with high-end designs",
        "Full-cycle support from conceptualization to delivery",
        "Enhanced brand awareness and interest with designs"
      ],
      image: img4
    },
    "video-editing-services": {
      title: "The best Video Editing Company in Alwar?",
      content: "RashTech Info vows to collaborate with a talented pool of professionals who blend technical expertise and narration to provide impactful output. With the title of Best Video Editing Company in Alwar, we help businesses, brands, and individuals create professional videos that are seen and remembered. We have been offering Video Editing Services in Alwar, India, and globally, catering to USA, UK, UAE, Canada, and Australia-based clients since 2018.",
      listItems: [
        "Expertise in promotional, corporate, and social media videos",
        "Experienced editors with international project experience",
        "Cost-effective prices without sacrificing quality",
        "Concept to last-mile delivery support",
        "Videos produced to generate engagement and conversions"
      ],
      image: img5
    },
    "ui-ux-development-services": {
      title: "The Best UI/UX Development Company in Alwar?",
      content: "Selecting RashTech Info involves collaborating with a design agency that blends creativity with usability to create results. We are the Best UI/UX Development Company in Alwar and specialize in creating digital experiences that are both aesthetically pleasing and user behavior as well as business goal-focused. We have been offering UI/UX Development Services in Alwar, India, and worldwide since 2018, assisting startups, SMEs, and businesses in establishing robust digital identities.",
      listItems: [
        "Web, mobile, and enterprise-level UI/UX expertise",
        "Experience of working with Indian clients and foreign markets",
        "Affordable design solutions without compromising on quality",
        "Full end-to-end design cycle from research to testing",
        "Prioritization of designs that boost engagement and conversions"
      ],
      image: img6
    },
    "custom-software-services": {
      title: "Best Custom Software Development Company in Alwar?",
      content: "Collaborating with RashTech Info is engaging a technology partner who comprehends your business issues and provides software that addresses them. We have been recognized as Alwar's Best Custom Software Development Company since 2018, providing end-to-end solutions that are innovative, scalable, and cost-effective. Compared to off-the-shelf software, which is meant to accommodate all, our tailor-made applications are developed around your unique processes, hence more efficient, user-friendly, and responsive to future requirements.",
      listItems: [
        "End-to-end solutions from design to maintenance",
        "Expertise in enterprise, web & desktop apps",
        "Affordable, scalable & high-quality software",
        "Proven success in India & abroad",
        "Regular updates, security & strong support"
      ],
      image: img7
    },
    "e-commerce-solutions-services": {
      title: "The Most Reliable E-commerce Development Company in Alwar?",
      content: "Working with RashTech Info means partnering with a team skilled in technical know-how, creativity, and online business expertise. Since 2018, we’ve helped startups, SMEs, and enterprises build online stores that drive sales. As the best eCommerce development company in Alwar, we deliver scalable, secure, and user-friendly solutions across India and serve clients in the USA, UK, UAE, Canada, and Australia.",
      image: img8,
      listItems: [
        "Custom storefront design for a unique brand identity.",
        "Secure payment gateways for a smooth checkout experience.",
        "Efficient product and inventory management from one dashboard.",
        "Mobile-friendly design for a seamless shopping experience.",
        "Data-driven sales analytics to boost your revenue."
      ]
    },
    "web-development-services": {
      title: "The Best Web Development Company in Alwar?",
      content: "Partnering with RashTech Info means working with a team that combines creativity, technology, and strategy to deliver top-quality websites. Since 2018, we've been helping businesses in Alwar and beyond establish strong digital footprints with websites that are not only visually appealing but also optimized for performance and conversions.",
      listItems: [
        "Websites tailored to your specific business goals.",
        "Reliable, scalable web stores with seamless checkout processes.",
        "Mobile-optimized layouts that work flawlessly on any device.",
        "Simple-to-maintain WordPress, Shopify, or custom CMS implementation.",
        "High-scalability apps for enterprises requiring advanced functionality."
      ],
      image: img9
    }
  };

  // Get content for current slug or return null if not found
  const content = contentMap[slug];
  
  if (!content) return null;

  return (
    <section className="why_choose_us_section section_space">
      <div className="container">
        <div className="row why_choose_us_row">
          {/* Image Column - Will appear first on tablet devices */}
          <div className="col-lg-6 col-md-12 col-sm-12 order-md-1 order-lg-0">
            <div className="image_container">
              <img 
                src={content.image} 
                alt={content.title} 
                className="why_choose_us_image" 
              />
            </div>
          </div>
          
          {/* Content Column - Will appear second on tablet devices */}
          <div className="col-lg-6 col-md-12 col-sm-12 order-md-2 order-lg-1">
            <div className="content_container">
              <h2 className="section_title">
                Why Choose RashTech Info – {content.title}
              </h2>
              <p className="content_text">{content.content}</p>
              
              {content.content2 && <p className="content_text">{content.content2}</p>}
              
              {content.subtitle && <h4 className="subtitle">{content.subtitle}</h4>}
              
              {content.listItems && (
                <ul className="feature_list">
                  {content.listItems.map((item, index) => (
                    <li key={index} className="feature_item">
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .why_choose_us_section {
          padding: 60px 0;
          margin-top: -80px
         
        }
        
        .why_choose_us_row {
          align-items: center;
          min-height: 500px;
          
        }
        
        .image_container {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }
        
        .why_choose_us_image {
          width: 100%;
          height: auto;
          max-height: 450px;
          object-fit: cover;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
          
        }
        
        .content_container {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 30px 20px 30px 40px;
          
        }
        
        .section_title {
          font-size: 1.8rem;
          font-weight: 700;
          margin-bottom: 20px;
          color: #333;
          line-height: 1.3;
        }
        
        .content_text {
          font-size: 1rem;
          line-height: 1.7;
          color: #666;
          margin-bottom: 20px;
        }
        
        .feature_list {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .feature_item {
          position: relative;
          padding: 10px 0 10px 32px;
          font-size: 0.95rem;
          line-height: 1.6;
          color: #555;
          border-bottom: 1px solid #f0f0f0;
        }
        
        .feature_item:before {
          content: "✓";
          position: absolute;
          left: 0;
          top: 10px;
          color: #007bff;
          font-weight: bold;
          font-size: 1.1rem;
        }
        
        .feature_item:last-child {
          border-bottom: none;
        }
        
        /* Large Desktop (1200px and above) */
        @media (min-width: 1200px) {
          .why_choose_us_row {
            min-height: 500px;
          }
          
          .section_title {
            font-size: 2rem;
          }
          
          .content_container {
            padding: 30px 20px 30px 50px;
          }
          
          .why_choose_us_image {
            max-height: 600px;
          }
        }
        
        /* Desktop (992px - 1199px) */
        @media (min-width: 992px) and (max-width: 1199px) {
          .why_choose_us_row {
            min-height: 450px;
          }
          
          .section_title {
            font-size: 1.7rem;
          }
          
          .why_choose_us_image {
            max-height: 400px;
          }
        }
        
        /* Tablet Landscape (768px - 991px) */
        @media (min-width: 768px) and (max-width: 991px) {
          .why_choose_us_section {
            padding: 50px 0;
          }
          
          .why_choose_us_row {
            min-height: auto;
            flex-direction: column;
          }
          
          .image_container {
            height: auto;
            padding: 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
            
          }
          
          .content_container {
            padding: 20px 15px 20px 25px;
            text-align: left;
            justify-content: flex-start;
            
          }
          
          .section_title {
            font-size: 1.5rem;
            margin-bottom: 15px;
            text-align: center;
          }
          
          .content_text {
            font-size: 0.95rem;
            line-height: 1.6;
            margin-bottom: 15px;
            text-align: left;
          }
          
          .why_choose_us_image {
            max-height: 350px;
            width: 100%
          }
          
          .feature_item {
            padding: 8px 0 8px 28px;
            font-size: 0.9rem;
            text-align: left;
          }
          
          .feature_item:before {
            top: 8px;
            font-size: 1rem;
          }
        }
        
        
        
        /* Mobile Landscape (576px - 599px) */
        @media (min-width: 576px) and (max-width: 599px) {
          .why_choose_us_section {
            padding: 40px 0;
          }
          
          .why_choose_us_row {
            min-height: auto;
            flex-direction: column;
          }
          
          .image_container {
            height: 280px;
            padding: 10px;
            margin-bottom: 0;
          }
          
          .content_container {
            padding: 25px 15px;
            text-align: left;
          }
          
          .section_title {
            font-size: 1.4rem;
            margin-bottom: 15px;
            text-align: center;
          }
          
          .content_text {
            font-size: 0.95rem;
            text-align: left;
          }
          
          .why_choose_us_image {
            max-height: 280px;
            width: 100%;
          }
          
          .feature_item {
            padding: 8px 0 8px 28px;
            font-size: 0.9rem;
            text-align: left;
          }
        }
        
        /* Mobile Portrait (below 576px) */
        @media (max-width: 575px) {
          .why_choose_us_section {
            padding: 30px 0;
            
          }
          
          .why_choose_us_row {
            min-height: auto;
            flex-direction: column;
          }
          
          .image_container {
            height: 220px;
            padding: 0;
            margin-bottom: 0;
          }
          
          .content_container {
            padding: 20px 0px;  
            text-align: left;
            
          }
          
          .section_title {
            font-size: 1.3rem;
            margin-bottom: 15px;
            line-height: 1.4;
            text-align: center;
          }
          
          .content_text {
            font-size: 0.9rem;
            line-height: 1.6;
            text-align: left;
          }
          
          .why_choose_us_image {
            max-height: 220px;
            width: 100%;
          }
          
          .feature_item {
            padding: 7px 0 7px 25px;
            font-size: 0.85rem;
            text-align: left;
          }
          
          .feature_item:before {
            top: 7px;
            font-size: 1rem;
          }
        }
        
        /* Extra Small Devices (below 400px) */
        @media (max-width: 400px) {
          .image_container {
            height: 200px;
          }
          
          .section_title {
            font-size: 1.2rem;
          }
          
          .content_text {
            font-size: 0.85rem;
          }
          
          .why_choose_us_image {
            max-height: 200px;
            width: 100%;
          }
          
          .feature_item {
            font-size: 0.8rem;
            padding: 6px 0 6px 22px;
          }
        }
        
        /* Ultra Wide Screens (1800px and above) */
        @media (min-width: 1800px) {
          .why_choose_us_row {
            min-height: 550px;
          }
          
          .section_title {
            font-size: 2.2rem;
          }
          
          .content_text {
            font-size: 1.1rem;
          }
          
          .why_choose_us_image {
            max-height: 550px;
          }
          
          .feature_item {
            font-size: 1rem;
          }
        }
      `}</style>
    </section>
  );
};

export default WhyChooseUs;